import Vue, { PropOptions } from 'vue';
import * as PClass from '@/class';
import TopBar from '@/components/TopBar.vue';
import DispsetModal from '@/components/DispsetModal.vue';
import parts from '@/parts';
import * as TypeVariable from '@/parts/VariableInput.vue';
import * as Models from '@/class/models/views';

export default Vue.extend({
  name: 'MixinsViews2',
  components: { ...parts, TopBar, DispsetModal},
  props: {
    confirmDialog: Function,
    getDatas: Object as PropOptions<Models.IGetDatas>,
    localDatas: Object as PropOptions<Models.ILocalDatas>,
  },
  data() {
    return {
      mode: PClass.CONST.MODE.NORMAL,
      thDatas: [] as TypeVariable.IVariableInput[],
      dispDatas: [] as any[],
      stackDatas: [] as any[],
      localData: {} as Models.ILocalData,
      listDispModal: false,
      getClientDatas: [] as Models.IClient[],
      dispSearchWord: '',
      dispDataCount: 0,
      items: [] as TypeVariable.IVariableInput[],
      localKey: '' as keyof Models.ILocalDatas,
      antiLoad: 0,
      ngSearchWord: '',
    };
  },
  computed: {
    MODE_NEW(): string { return PClass.CONST.MODE.NEW; },
    MODE_EDIT(): string { return PClass.CONST.MODE.EDIT; },
    MODE_NORMAL(): string { return PClass.CONST.MODE.NORMAL; },
    MODE_SELECT(): string { return PClass.CONST.MODE.SELECT; },
    dispThDatas(): any[] {
      if (this.localData.disp) {
        return this.thDatas.filter((v, n) => (this.localData.disp[n]))
      } else {
        return this.thDatas
      }
    },
    dispTrDatas(): any[] {
      return this.dispDatas ? this.dispDatas
        .map((v) => {
          if (v) {
            const responsiblecoordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === v.responsibleID));
            v.responsibleName = responsiblecoordinator ? responsiblecoordinator.coordinatorName : v.responsibleID === 0 ? '未設定' : '削除済';
          }
          return v
        }) : [];
    },
    trNgDatas(): any[] {
      const data = this.getDatas.getClientDatas.filter((v) => (JSON.stringify(v).indexOf(this.ngSearchWord) >= 0));
      return data;
    },
  },
  async mounted() {
  },
  methods: {
    async fncGetDatas(initials: boolean) {
      // 共通初回操作
      const firstFlag = this.getDatas.getCoordinatorDatas.length === 0 || this.getDatas.getClientDatas.length === 0;
      let coordinatorIDs = [] as number[];
      let searchWord = '';
      let skip = this.dispDatas.length === 0 ? 0 : Math.floor(this.dispDatas.length / 100)

      // イニシャライズフラグ
      if (initials) {
        this.$emit('loading', true);
        this.dispDataCount = 0;
        skip = 0;
      }

      // searchフラグ検索
      if (this.localData.word && this.localData.word !== '') {
        coordinatorIDs = this.localData.searchIDs;
        searchWord = this.localData.word;
        this.dispSearchWord = searchWord;
      }

      this.fncAntiLoading();
      const api = new PClass.API();
      const res = await api.get<Models.VGetDatas>(this.localKey, {firstFlag, skip, coordinatorIDs, searchWord, target: this.localData.target, asc: this.localData.asc} as Models.ISortData);
      if (!res.result.error) {
        if (firstFlag) {
          this.getDatas.getCoordinatorDatas = res.data.coordinators;
          this.getDatas.getClientDatas = res.data.clients;
        }
        const findItems = this.items.find((v) => (v.key === 'responsibleID'));
        if (findItems) {
          findItems.options = PClass.CONST.ARRAY.NORMAL.concat(this.getDatas.getCoordinatorDatas.map((v) => ({text: v.coordinatorName, value: v.id})));
        }
        if (skip === 0) {
          this.dispDataCount = res.data.count;
          this.stackDatas = res.data.datas;
          this.dispDatas = this.stackDatas.slice(0, 50);
        } else {
          this.stackDatas = res.data.datas;
          this.dispDatas = this.dispDatas.concat(this.stackDatas.slice(0, 50))
        }
      } else {
        // this.$emit('change', NOC.APP.MODE.LOGIN);
        this.$emit('info', 'エラーが発生しました。');
        (this.$refs.infiniteLoading as any).stateChanger.complete();
      }

      if (initials) {
        (this.$refs.infiniteLoading as any).stateChanger.reset();
        this.$emit('loading', false);
      }
    },
    async fncGetDatasKey(key?: string) {
      this.$emit('loading', true);

      if (key) {
        // ローカルデータ更新
        if (this.localData.target === key) {
          this.localData.asc = !this.localData.asc
        } else {
          this.localData.target = key;
          this.localData.asc = false;
        }
      } else {
        const responsiblecoordinator = this.getDatas.getCoordinatorDatas.filter((s) => (s.coordinatorName.indexOf(this.dispSearchWord) >= 0));
        this.localData.searchIDs = responsiblecoordinator.map((v) => v.id);
        this.localData.word = this.dispSearchWord;
      }
      // ※props操作
      this.localDatas[this.localKey] = this.localData;
      this.$emit('setLocalDatas')
      // データ取得
      await this.fncGetDatas(true);
      this.$emit('loading', false);
    },
    async fncAntiLoading() {
      this.antiLoad++;
      await (this.wait(3))
      if (this.antiLoad > 2) {
        (this.$refs.infiniteLoading as any).stateChanger.complete();
      }
      this.antiLoad = 0;
    },
    async wait(second: number) {
      return new Promise((resolve) => setTimeout(() => resolve(true), 1000 * second));
    },
    onClickDesideListDispModal(list: boolean[]) {
      this.localData.disp = list;
      this.localDatas[this.localKey] = this.localData;
      this.$emit('setLocalDatas')
      this.listDispModal = false;
    },
    async onClickClear() {
      this.dispSearchWord = '';
      if (!this.localData.word || this.localData.word === '') {
        return;
      }
      await this.fncGetDatasKey();
    },
    async mixInfiniteHandler($state: any) {
      this.dispDatas = this.dispDatas.concat(this.stackDatas.slice(50))
      if (this.dispDataCount <= this.dispDatas.length) {
        $state.complete();
      } else {
        await this.fncGetDatas(false);
        if (this.dispDataCount <= this.dispDatas.length) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }
    },
    async mixDeleteAction(message: string, deleteData: any) {
      if (await this.confirmDialog(message)) {
        this.$emit('loading', true);
        const api = new PClass.API();
        const res = await api.delete<Models.VAnnkenn>(this.localKey, {id: deleteData.id});
        if (!res.result.error) {
          // await this.fncGASData();
        } else {
          this.$emit('info', res.result.message);
        }
        this.$emit('loading', false);
      }
    },
    mixSetLocalData() {
      // ローカルデータ読み込み
      if (this.localDatas[this.localKey]) {
        this.localData.target = this.localDatas[this.localKey].target;
        this.localData.asc = this.localDatas[this.localKey].asc;
        if (this.localDatas[this.localKey].disp) {
          if (this.localDatas[this.localKey].disp.length === this.localData.disp.length) {
            this.localData.disp = this.localDatas[this.localKey].disp;
          }
        }
        this.localData.word = this.localDatas[this.localKey].word;
        this.localData.searchIDs = this.localDatas[this.localKey].searchIDs;
      }
    },
    mixChangeModeNew() {
      this.mode = PClass.CONST.MODE.NEW;
    },
    mixChangeModeEdit() {
      this.mode = PClass.CONST.MODE.EDIT;
    },
    mixChangeModeNORMAL() {
      this.mode = PClass.CONST.MODE.NORMAL;
    },
    mixChangeModeSELECT() {
      this.mode = PClass.CONST.MODE.SELECT;
    },
    mixChangeMode(nextMode: string) {
      this.mode = nextMode;
    },
    mixGetMode() {
      return this.mode;
    },
  },
});
